<div class="containerWrapper">
  <img src="assets/images/build_from_desktop.png" alt="" />
  <h1>{{ 'In Trial Mode, we disabled accessing the builder from a mobile view So that you can get the best user-experience' | translate }}</h1>
  <p>{{ 'Please consider opening Stacks Builder from Desktop or Laptop for the best user experience' | translate }}</p>
  <p>Hint: We have sent you an email with login link to be opened from the desktop</p>
</div>
